export const FETCH_COUNTRIES_REQUEST = "FETCH_COUNTRIES_REQUEST";
export const FETCH_COUNTRIES_SUCCESS = "FETCH_COUNTRIES_SUCCESS";
export const FETCH_COUNTRIES_FAILURE = "FETCH_COUNTRIES_FAILURE";
export const SET_COUNTRY = "SET_COUNTRY"
export const SET_CONVERSION_RATE = "SET_CONVERSION_RATE"
export const SET_LANGUAGES = "SET_LANGUAGES"